import {
    URLAPI,
    PROVINCES_PATH,
    PROVINCE_CREATE_PATH,
    PROVINCE_UPDATE_PATH,
} from "../config/index";
import {LOGOUT} from './users'
import axios from "axios";

const init = {
    _get_all_provinces: {
        data: [],
        status: 0,
        message: {},
    },
    _create_province: {
        data: {},
        status: 0,
        message: {},
    },
    _update_province: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_PROVINCES = "GET_ALL_PROVINCES";
export const CREATE_PROVINCE = "CREATE_PROVINCE";
export const UPDATE_PROVINCE = "UPDATE_PROVINCE";

export const provinces_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_PROVINCES:
            return {
                ...state,
                _get_all_provinces: action.payload,
            };
        case CREATE_PROVINCE:
            return {
                ...state,
                _create_province: action.payload,
            };
        case UPDATE_PROVINCE:
            return {
                ...state,
                _update_province: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllProvinces = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${PROVINCES_PATH}`, {
            headers: {
                Authorization: `Basic ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_PROVINCES,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_PROVINCES,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_PROVINCES,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const createProvince = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${PROVINCE_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_PROVINCE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_PROVINCE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_PROVINCE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateProvince = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.patch(
            `${URLAPI}${PROVINCE_UPDATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_PROVINCE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_PROVINCE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_PROVINCE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_provinces = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
